import React from 'react';
import type { Product } from '../../../types';
import { formatCurrency } from '../../../utils/formatting';

interface SummaryItemProps {
  item: Product;
}

const SummaryItem: React.FC<SummaryItemProps> = ({ item }) => {
  return (
    <div className="flex items-start py-3 border-b border-gray-200 dark:border-gray-700 last:border-b-0">
      <img src={item.imageUrl} alt={item.name} className="w-16 h-16 object-cover rounded-md mr-4"/>
      <div className="flex-1">
        <h4 className="text-xs font-medium text-text-primary dark:text-gray-100 opacity-70 mb-2">{item.name}</h4>
        {item.properties && Object.entries(item.properties).length > 0 && (
          <div className="text-xs text-text-secondary dark:text-gray-400 mb-1">
            {Object.entries(item.properties).map(([key, value]) => (
              <p key={key}>{key}: {value}</p>
            ))}
          </div>
        )}
        <p className="text-xs text-text-secondary dark:text-gray-400">Qtd: {item.quantity}</p>
      </div>
      <p className="text-sm font-semibold text-text-primary dark:text-gray-100 pl-2">
        {formatCurrency(item.totalPrice)}
      </p>
    </div>
  );
};

export default SummaryItem; 